import horizon from "../icons/horizon/index.js";
import emarsys from "../icons/emarsys/index.js";

import deepMerge from "./utils/deep-merge.js";

const iconConfigs = {
  horizon,
  emarsys,
};

const iconSets = {};

for (const [name, iconConfig] of Object.entries(iconConfigs)) {
  const baseGlyphs = iconConfig.extend?.glyphs || {};
  const glyphs = deepMerge(baseGlyphs, iconConfig.glyphs || {});

  iconSets[name] = {
    name: iconConfig.name,
    glyphs,
  };
}

export default iconSets;
